import { render, staticRenderFns } from "./btnRating.vue?vue&type=template&id=1ef839d2&"
import script from "./btnRating.vue?vue&type=script&lang=js&"
export * from "./btnRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports